function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 2A1.5 1.5 0 011.5.5h11A1.5 1.5 0 0114 2v12a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 010 14V2zm1.5-.5A.5.5 0 001 2v12a.5.5 0 00.5.5h11a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5h-11z",
  clipRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.5 3a.5.5 0 01.5.5V14a1.5 1.5 0 01-1.5 1.5h-3v-1h3a.5.5 0 00.5-.5V3.5a.5.5 0 01.5-.5z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 3h10v2H2V3zm0 3h4v3H2V6zm0 4h4v1H2v-1zm0 2h4v1H2v-1zm5-6h2v1H7V6zm3 0h2v1h-2V6zM7 8h2v1H7V8zm3 0h2v1h-2V8zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1z"
});

function SvgBlog(props) {
  return React.createElement("svg", _extends({
    className: "blog_svg__bi blog_svg__bi-newspaper",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iYmkgYmktbmV3c3BhcGVyIiB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJjdXJyZW50Q29sb3IiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMCAyQTEuNSAxLjUgMCAwMTEuNS41aDExQTEuNSAxLjUgMCAwMTE0IDJ2MTJhMS41IDEuNSAwIDAxLTEuNSAxLjVoLTExQTEuNSAxLjUgMCAwMTAgMTRWMnptMS41LS41QS41LjUgMCAwMDEgMnYxMmEuNS41IDAgMDAuNS41aDExYS41LjUgMCAwMC41LS41VjJhLjUuNSAwIDAwLS41LS41aC0xMXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1LjUgM2EuNS41IDAgMDEuNS41VjE0YTEuNSAxLjUgMCAwMS0xLjUgMS41aC0zdi0xaDNhLjUuNSAwIDAwLjUtLjVWMy41YS41LjUgMCAwMS41LS41eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+CiAgPHBhdGggZD0iTTIgM2gxMHYySDJWM3ptMCAzaDR2M0gyVjZ6bTAgNGg0djFIMnYtMXptMCAyaDR2MUgydi0xem01LTZoMnYxSDdWNnptMyAwaDJ2MWgtMlY2ek03IDhoMnYxSDdWOHptMyAwaDJ2MWgtMlY4em0tMyAyaDJ2MUg3di0xem0zIDBoMnYxaC0ydi0xem0tMyAyaDJ2MUg3di0xem0zIDBoMnYxaC0ydi0xeiIvPgo8L3N2Zz4=";
export { SvgBlog as ReactComponent };